import React from 'react';

import { ButtonWithForwardedRef, DropdownToggleProps, Icon } from '@neptune/shared/venus-ui';

export const DotsHButton = React.forwardRef<HTMLButtonElement | null, DropdownToggleProps>(
  function DotsHButton({ onCollapse, onExpand, onToggle, size = 'lg', ...restProps }, ref) {
    return (
      <ButtonWithForwardedRef
        size={size}
        variant="transparent"
        square
        onClick={onToggle}
        {...restProps}
        ref={ref}
      >
        <Icon glyph="dots-horizontal" />
      </ButtonWithForwardedRef>
    );
  },
);
